<template lang="html">
  <div
    class="user-profile"
    :class="[cardName, { active: user.id === userId }]"
    v-if="user"
  >
    <div class="avatar" @click="userDetail(user)">
      <img :src="user.headPicUrl | avatar(90, 90)" alt="" />
    </div>
    <div
      class="profile-summary"
      @click="userDetail(user)"
      v-if="cardName === 'bigcard'"
    >
      <div class="name" :class="{ unserve: !canServe }">
        <p>{{ user.name }}</p>
        <p v-if="user.sourceName">
          <i :class="{ out: user.source === 'pop' }">{{ user.sourceName }}</i>
        </p>
      </div>
      <!-- <div class="start-level">
                <star :score="user.score" size="medium" color="#ffc600" :scoreNo="user.startLevel"  :levelName="user.startLevelName"></star>
            </div> -->
      <div class="area-serve">
        <p>
          服务：<span v-for="place in user.schedualAreas"
            >{{ place.districtName }}
          </span>
        </p>
        <!-- <p v-if="user.distance !== 0" class="distance">{{user.distance / 1000}}km</p> -->
      </div>
    </div>
    <div class="profile-summary" @click="userDetail(user)" v-else>
      <div class="name">
        <p>{{ user.name }}</p>
        <!-- <star :score="user.score" :scoreNo="user.startLevel" :levelName="user.startLevelName"></star> -->
        <p v-if="user.sourceName">
          <i :class="{ out: user.source === 'pop' }">{{ user.sourceName }}</i>
        </p>
      </div>
      <div class="area-serve">
        <p>
          服务：<span v-for="place in user.schedualAreas">{{
            place.districtName
          }}</span>
        </p>
        <!-- <p v-if="user.distance && user.distance !== 0" class="distance">{{user.distance / 1000}}km</p> -->
      </div>
    </div>
    <div
      class="arrow"
      v-if="showArrow && user.is_del !== 0 && !isMp"
      @click.stop="gotoUserDetail(user)"
    >
      <i class="iconfont icon-jiantou"></i>
    </div>
  </div>
</template>

<script>
import star from '@/components/common/star'

export default {
  props: {
    // 是否显示箭头
    showArrow: {
      type: Boolean,
      default: true
    },
    // 是否显示地址
    showAddress: {
      type: Boolean,
      default: true
    },
    // 用户样式类名
    cardName: {
      type: String,
      default: ''
    },
    // 是否可服务
    canServe: {
      type: Boolean,
      default: true
    },
    // 用户信息
    user: {
      type: Object,
      default: () => {}
    },
    // 已选中用户的id
    userId: {
      type: [Number, String],
      default: -1
    }
  },
  data() {
    return {
      isMp: this.$$isMp()
    }
  },
  methods: {
    userDetail(user) {
      // this.$store.commit('setSelectedWorker',)
      if (this.canServe) {
        this.$emit('userDetail', user)
      } else {
        // this.$$toast('该人员不提供服务')
      }
    },
    score(score) {
      if (score === '' || score === '0') {
        return 0
      } else {
        return Math.ceil(score / 2)
      }
    },
    gotoUserDetail(user) {
      if (user.is_del === 0 || !user.uid) {
        // 0离职，1在职
        return
      }
      if (this.$$isMp()) {
        return
      }
      this.$$tracker('110101', '20000', 21043, user.code)
      // if (user.source !== 'pop') {
      //     location.href = `${this.$$hostname('shequ')}/bbs/user/${user.uid}`
      // } else {
      location.href = `/v/user/${user.uid}`
      // }
    }
  },
  components: {
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.user-profile {
  display: flex;
  // align-items: center;

  .avatar {
    width: rem(60px);
    height: rem(60px);
    margin-right: rem(20px);
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .profile-summary {
    flex: 1;

    .name {
      display: flex;
      align-items: center;
      font-size: rem(28px);

      > p:first-of-type {
        margin-right: rem(12px);
      }

      i {
        display: inline-block;
        margin-left: rem(5px);
        padding: rem(3px) rem(5px);
        background: #ff397e;
        font-size: rem(22px);
        color: #fff;
        border-radius: rem(4px);

        &.out {
          background-color: #ffb83b;
        }
      }
    }
    .unserve i {
      background: #d7d7d7;
    }

    .area-serve {
      display: flex;
      align-items: center;
      margin-top: rem(10px);
      font-size: rem(22px);
      color: #999;

      > p:first-of-type {
        flex: 1;
        line-height: 1.3;
      }
      .distance {
        margin-left: rem(20px);
      }
      span {
        margin-right: rem(10px);
      }
    }
  }
  .start-level {
    margin-top: rem(10px);
  }
  .arrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    z-index: 2;
    padding: rem(15px);
    padding-right: 0;
    width: rem(50px);
  }
  .icon-jiantou {
    display: inline-block;
    font-size: rem(30px);
    transform: rotate(-90deg);
  }
}
.bigcard {
  .name {
    margin-bottom: rem(10px);
    line-height: rem(24px);

    // i{
    //     display: inline-block;
    //     margin-left: rem(5px);
    //     padding: rem(3px) rem(5px);
    //     background: #ff397e;
    //     font-size: rem(22px);
    //     color: #fff;
    //     border-radius: rem(4px);
    // }
  }
  .avatar {
    width: rem(90px);
    height: rem(90px);
  }
  .unserve {
    color: #666;
    i {
      background: #d7d7d7;
    }
  }
}
.active {
  background: #ffe7ef;
}
</style>
